import Luiv3Constants, {LuiV3ColorKey} from '@app/lui3/constants';
import styled from 'styled-components';

import BtnContainer from '../BtnContainer';
import AbsLayer from './AbsLayer';

interface Props {
  backgroundColor: LuiV3ColorKey;
  hoverColor?: LuiV3ColorKey;
}

const FilledBaseLayer = styled(AbsLayer)<Props>`
  --hover-bg-color: ${({hoverColor, backgroundColor}) =>
    Luiv3Constants.baseColor[hoverColor ?? backgroundColor]};

  background-color: ${({backgroundColor}) =>
    Luiv3Constants.baseColor[backgroundColor]};

  ${BtnContainer}:hover & {
    background-color: var(--hover-bg-color) !important;
  }
`;

export default FilledBaseLayer;
